export enum BusinessUnit {
  AS = 'as',
  EP = 'ep',
  EP_AMERICA = 'ep-america'
}

export enum UserRole {
  GLOBAL = 'global',
  ELPAIS = 'elpais',
  ELPAIS_AMERICA = 'elpais-america',
  DIARIOAS = 'diarioas'
}

export const BrandLogos = {
  [BusinessUnit.AS]: `${process.env.PUBLIC_URL}/editions/diarioas.webp`,
  [BusinessUnit.EP]: `${process.env.PUBLIC_URL}/editions/elpais.webp`,
  [BusinessUnit.EP_AMERICA]: `${process.env.PUBLIC_URL}/editions/elpais.webp`
}
